import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  message: '',
  token: '',
  usdAmount: 0,
  tokenAmount: '', // New state for the local currency amount
  tokenPriceUSD: '', // New state for the local currency amount
  image: null,
  email: '',
};

const customizeCardSlice = createSlice({
  name: 'customizeCard',
  initialState,
  reducers: {
    setMessage(state, action) {
      state.message = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
      state.image = null;
    },
    setReceiverEmail(state, action) {
      state.email = action.payload;
    },
    setUsdAmount(state, action) {
      state.usdAmount = action.payload;
    },
    setTokenAmount(state, action) {
      state.tokenAmount = action.payload;
    },
    setTokenPriceUSD(state, action) {
      state.tokenPriceUSD = action.payload;
    },
    setImage(state, action) {
      state.image = action.payload;
    },
  },
});

export const selectMessage = (state) => state.customizeCard.message;
export const selectToken = (state) => state.customizeCard.token;
export const selectUsdAmount = (state) => state.customizeCard.usdAmount;
export const selectTokenPriceUSD = (state) => state.customizeCard.tokenPriceUSD;
export const selectCardImage = (state) => state.customizeCard.image;
export const selectCardReceiverEmail = (state) => state.customizeCard.email;
export const selectTokenAmount = (state) => state.customizeCard.tokenAmount;

export const {
  setMessage,
  setToken,
  setReceiverEmail,
  setUsdAmount,
  setTokenAmount,
  setTokenPriceUSD,
  setImage,
} = customizeCardSlice.actions;

export default customizeCardSlice.reducer;
